module.exports = __webpack_public_path__ + "static/media/shoprite.6532990d.svg";